/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Finding_Not_A_FindingInputs */

const es_co2_error_finding_not_a_finding = /** @type {(inputs: Error_Finding_Not_A_FindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El registro no es un hallazgo.`)
};

/**

* @param {Error_Finding_Not_A_FindingInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_finding_not_a_finding = /** @type {((inputs?: Error_Finding_Not_A_FindingInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Finding_Not_A_FindingInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_finding_not_a_finding(inputs)
});